import { httpStatus } from '../enums/httpResponseEnum'
import { SnackBarModel } from '../components/snackBar/types/SnackBarModel'
import { INITIAL_SNACKBAR } from '../components/snackBar/context/SnackBarContext'

const messageErreur: string = 'Une erreur est survenue lors de la requête, veuillez réessayer plus tard'

const errorCatcher = (error: any, id: string): SnackBarModel => {
	if (error.errors) {
		console.error(error.errors._error)
		return (
			{
				id: id,
				message: error.errors._error,
				open: true,
				hideIcon: true
			}
		)
	} else if (error.status === httpStatus.INTERNAL) {
		console.error(messageErreur)
		return (
			{
				id: id,
				message: messageErreur,
				open: true,
				hideIcon: true
			}
		)
	} else if (error.response && error.response.status === httpStatus.BAD_REQUEST) {
		console.error(error.response.statusText + ' : ' + error.bodyError)
		return (
			{
				id: id,
				message: error.bodyError,
				open: true,
				hideIcon: true
			}
		)
	} else if (error.status === httpStatus.BAD_REQUEST) {
		console.error('Erreur: Les valeurs saisies sont incorrectes')
		return (
			{
				id: id,
				message: 'Les valeurs saisies sont incorrectes.',
				open: true,
				hideIcon: true
			}
		)
	} else if (typeof error === 'string') {
		console.error('Erreur: ' + error)
		return (
			{
				id: id,
				message: error,
				open: true,
				hideIcon: true
			}
		)
	}
	return INITIAL_SNACKBAR
}

export default errorCatcher